import * as R from 'ramda'
import axios from 'axios'
const formatter = {
  'パターン': (value) => Number(value),
  '単位数': (value) => Number(value)
}
export const setupReplaceTableCSV = (replaceTable) => {
  return R.pipe(
    R.map(o => R.evolve(formatter, o)),
    R.filter(p => p['単位数'] !== 0)
  )(replaceTable)
}


export const fetchIgnoreStudentsCSV = () => {
  return axios.get('./ignorestudents.json')
    .then(response => response.data)
}